import {Link} from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';

import {ROLE_ADMIN} from '../constants/userConstants';
import {theme} from '../constants/styled';
import ExcelDownload from './ExcelDownload';

const NaviItem = styled.div`
  line-height: 50px;
  font-size: 25px;
  font-weight: 200;
  display: block;
  &:first-of-type {
    margin-top: 200px;
  }
  a,
  a:hover {
    color: ${props => props.theme.primaryColor};
    text-decoration: none;
  }
  div {
    color: white;
    padding-top: 60px;
    cursor: pointer;
  }
`;

const _logout = () => {
  localStorage.removeItem('@wkoWindowStore:authToken');
  location.reload();
};
export const SidebarContent = ({user}) => {
  return (
    <div>
      <NaviItem>
        <a href={'/pdf/bedienungsanleitung.pdf'}>Bedienungsanleitung</a>
      </NaviItem>
      <NaviItem>
        <Link to={'/windows'}>Fensterübersicht</Link>
      </NaviItem>
      <NaviItem>
        <Link to={'/search'}>Fenster Suche</Link>
      </NaviItem>
      {user && user.role === ROLE_ADMIN && (
        <NaviItem>
          <Link to={'/metadatas'}>Metadaten</Link>
        </NaviItem>
      )}
      {user && user.role === ROLE_ADMIN && (
        <NaviItem>
          <Link to={'/users'}>Benutzer</Link>
        </NaviItem>
      )}
      {user && user.role === ROLE_ADMIN && (
        <NaviItem>
          <ExcelDownload />
        </NaviItem>
      )}
      <NaviItem>
        <a href={'/pdf/fenstereinbau.pdf'}>Fenstereinbau</a>
      </NaviItem>
      <NaviItem>
        <a href={'/pdf/kundenhandbuch2019.pdf'}>Kundenhandbuch</a>
      </NaviItem>
      <NaviItem>
        <div onClick={_logout}>Abmelden</div>
      </NaviItem>
    </div>
  );
};
export const sidebarStyles = {
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
  },
  sidebar: {
    zIndex: 2500,
    position: 'absolute',
    top: 0,
    bottom: 0,
    transition: 'transform .3s ease-out',
    WebkitTransition: '-webkit-transform .3s ease-out',
    willChange: 'transform',
    overflowY: 'auto',
    background: theme.secondaryColor,
    padding: 40,
    minWidth: 250,
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch',
    transition: 'left .3s ease-out, right .3s ease-out',
  },
  overlay: {
    zIndex: 2,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity .3s ease-out, visibility .3s ease-out',
    backgroundColor: 'rgba(0,0,0,.3)',
  },
  dragHandle: {
    zIndex: 1,
    position: 'fixed',
    top: 0,
    bottom: 0,
  },
};



// WEBPACK FOOTER //
// ./src/components/SidebarContent.js